import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function RotatingBanner() {
  const [ads, setAds] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/ads", { params: { type: "banner", placement: "home" } }).then(r => setAds(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => setIdx(i => (i + 1) % ads.length), 5000);
    return () => clearInterval(t);
  }, [ads.length]);

  if (!ads.length) return null;
  const ad = ads[idx];

  const onClick = () => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
    if (ad.link?.startsWith("http")) window.open(ad.link, "_blank");
    else if (ad.link) window.location.href = ad.link;
  };

  return (
    <div className="px-3 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <button
          type="button"
          data-testid="ads-banner"
          onClick={onClick}
          className="group w-full relative aspect-[16/7] sm:aspect-[21/7] rounded-2xl overflow-hidden bg-[#F3F1EC] border border-[#E8E6E1] active:scale-[0.99] transition"
        >
          <img
            key={ad.id}
            src={ad.image}
            alt={ad.title}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5 text-white text-left">
            <div className="text-[10px] uppercase tracking-widest font-bold opacity-80">Sponsorisé</div>
            <div className="font-[Manrope] font-extrabold text-lg sm:text-2xl leading-tight">{ad.title}</div>
          </div>
          <div className="absolute top-3 right-3 flex gap-1">
            {ads.map((_, i) => (
              <div key={i} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-5 bg-white" : "w-1.5 bg-white/50"}`} />
            ))}
          </div>
        </button>
      </div>
    </div>
  );
}
